/**
 * Format a typeId (e.g. "product_service") to a display name (e.g. "Product Service").
 * @param {string} typeId
 * @returns {string}
 */
export function formatTypeIdToDisplayName(typeId) {
  if (!typeId) return "";
  return typeId
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Get the default block name for a layout item.
 * If the item has block_name, return it. Otherwise generate from typeId with optional number suffix.
 * e.g. single "product_service" -> "Product Service", multiple -> "Product Service 1", "Product Service 2"
 * @param {Array} layout - full layout array
 * @param {Object} item - layout item with i, typeId, and optionally block_name
 * @returns {string}
 */
export function getDefaultBlockName(layout, item) {
  if (!item) return "";
  if (item.block_name && String(item.block_name).trim()) {
    return String(item.block_name).trim();
  }
  const typeId = item.typeId;
  const sameTypeItems = layout.filter((l) => l.typeId === typeId);
  const displayBase = formatTypeIdToDisplayName(typeId);
  if (sameTypeItems.length <= 1) {
    return displayBase;
  }
  const index = sameTypeItems.findIndex((l) => l.i === item.i);
  return `${displayBase} ${index + 1}`;
}

